import { registerRouteRedirectGuard } from '@experience/core-app-link-lib';
import SkeletonPlugin from '@experience/core-skeleton-lib';
import { VueQueryPlugin } from '@tanstack/vue-query';

import { getApiBaseUrl } from '@/shared/api/apiClient';
import { applyUnprefixedCityTagRedirect } from '@/shared/lib/unprefixedCityTagRedirect';

import type { CustomElementOptions } from 'vue';
import type { Router, RouterMatcher, RouterScrollBehavior } from 'vue-router';

type App = Parameters<NonNullable<CustomElementOptions['configureApp']>>[0];

/**
 * При пагинации (меняется только `?page`) возвращаем пользователя к началу списка,
 * в остальных случаях позицию скролла не трогаем.
 */
const reviewsScrollBehavior: RouterScrollBehavior = (to, from) => {
  if (to.path === from.path && to.query.page !== from.query.page) {
    return { top: 0, left: 0 };
  }

  return undefined;
};

const installUnprefixedCityTagRedirectGuard = (router: Router) => {
  router.beforeEach(async (to, _from, next) => {
    const didRedirect = await applyUnprefixedCityTagRedirect({
      pathname: to.path,
      urlTail: to.fullPath.slice(to.path.length),
      origin: window.location.origin,
      getApiBaseUrl,
    });

    if (didRedirect) {
      return;
    }

    next();
  });
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const initPlugins = (app: App, router: Router, matcher: RouterMatcher) => {
  app.use(VueQueryPlugin);
  app.use(SkeletonPlugin);

  // роутер создаётся шаблонным main.ts без scrollBehavior, поэтому доопределяем его здесь
  router.options.scrollBehavior = reviewsScrollBehavior;

  if (typeof history !== 'undefined' && 'scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  installUnprefixedCityTagRedirectGuard(router);
  registerRouteRedirectGuard(router);
};
